import { COMMON_MIXPANEL_PAGE } from '../../common/constants/mixpanelConstants'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const resourceCoordinatorMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.RESOURCE_COORDINATOR,
  iFrameSrcUrl: '/resource-coordinator-hub',
  micrositeUrl: 'social-care',
  title: {
    id: 'resourceCoordinator.title',
    defaultMessage: 'Resource Coordinator',
    description: 'Microsite page title for resource coordinator',
  },
  customerPropertyConditions: [],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.SCHEDULE_RESOURCE_COORDINATOR_CALL },
    { key: CMS_MICROSITE_MESSAGE_KEY.OPEN_CARE_NAVIGATOR_INFO },
  ],
  page: COMMON_MIXPANEL_PAGE.RESOURCE_COORDINATOR,
  shouldHideForInternational: false,
  usePageForViewEvent: true,
  trackEntryPoint: true,
}
